<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <MenuCard :menuItems="menuItems" />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import MenuCard from "@/components/MenuCard";

export default {
    page: {
        title: i18n.t("module.dashboard"),
    },
    components: { Layout, PageHeader, MenuCard },
    data() {
        return {
            title: i18n.t("module.dashboard"),
            items: [
                {
                    text: i18n.t("module.dashboard"),
                    active: true,
                },
            ],
            menuItems: [
                {
                    route: 'MeetingRoomBooking',
                    label: i18n.t('module.roomBooking'),
                    icon: 'mdi-cog-outline',
                    color: 'info',
                    core: true,
                },
                // {
                //     // route: 'Ticketing',
                //     label: i18n.t('module.ticketing'),
                //     icon: 'mdi-console',
                //     color: 'primary',
                //     externalLink: true,
                //     externalUrl: 'http://itsupport.hextar.com/',
                //     core: true,
                //     maintenance: true,
                // },
            ],
        };
    },
}
</script>